import apiClient from './config.js';

export default {
  async getNer(text, token) {
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
      }, ...config.headers };
      return config;
    });
    return await apiClient.post(`nlp/ner?text=${text}`);
  },
};